var _rect, _rect2, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgImagedelete(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 23,
    height: 23,
    rx: 3.5,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 23,
    height: 23,
    rx: 3.5,
    stroke: "#F4F4F4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 7.66675L16.5869 14.3501C16.4813 16.0577 16.4285 16.9115 16.0005 17.5253C15.7889 17.8288 15.5165 18.0849 15.2005 18.2774C14.5614 18.6667 13.706 18.6667 11.9951 18.6667C10.2821 18.6667 9.42553 18.6667 8.78603 18.2767C8.46987 18.0839 8.19733 17.8273 7.98579 17.5233C7.55792 16.9085 7.5063 16.0535 7.40307 14.3435L7 7.66675",
    stroke: "#E52333",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6 7.66659H18M14.7038 7.66659L14.2487 6.72774C13.9464 6.10409 13.7952 5.79227 13.5345 5.59779C13.4767 5.55465 13.4154 5.51628 13.3513 5.48305C13.0626 5.33325 12.7161 5.33325 12.023 5.33325C11.3125 5.33325 10.9573 5.33325 10.6638 5.48933C10.5987 5.52393 10.5367 5.56385 10.4782 5.6087C10.2144 5.81105 10.0671 6.13429 9.77241 6.78076L9.36861 7.66659",
    stroke: "#E52333",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImagedelete);
export default __webpack_public_path__ + "static/media/imagedelete.3da1bcecf880d93a4c37d06b2d8f28ee.svg";
export { ForwardRef as ReactComponent };